module.exports = __webpack_public_path__ + "img/travel.a9651a84.jpg";